//createRouter方法，用于创建路由器对象
//createWebHistory方法，用于创建history路由
//createWebHashHistory方法，用户创建hash路由

import { createRouter, createWebHistory} from 'vue-router'




//定义路由数组
const routes = [
  //每个路由，配置一个对象
  { 
    path: '/', //路由路径
    name:'home',//路由名称(可以省略)
    component: ()=>import('../views/home.vue') //路由组件 也可以用懒加载的模式，方法为()=>import()
    
  },
  {
    path:'/product',
    name:'product',
    component: ()=>import('../views/product.vue')
  },
  {
    path:'/user',
    name:'user',
    component: ()=>import('../views/user.vue')

  },
  {
    path:'/login',
    name:'login',
    component: ()=>import('../views/login.vue')

  },
  {
    path:'/register',
    name:'register',
    component: ()=>import('../views/register.vue')

  },
  {
    path:'/forgetPwd',
    name:'forgetPwd',
    component: ()=>import('../views/forgetPwd.vue')
  },
  {
    path:'/forgetSmsCode/:phone',
    name:'forgetSmsCode',
    component: ()=>import('../views/forgetSmsCode.vue')
  },
  {
    path:'/fixpassword',
    name:'fixpassword',
    component: ()=>import('../views/fixpassword.vue')
  },
  {
    path:'/passwordSuccess',
    name:'passwordSuccess',
    component: ()=>import('../views/passwordSuccess.vue')
  },
  {
    path:'/sells',
    name:'sells',
    component: ()=>import('../views/sells.vue')
  },
  {
    path:'/insure/:code',
    name:'insure',
    component: ()=>import('../views/insure.vue')
  },
  //销售中心
  {
    path:'/clientManage',
    name:'clientManage',
    component: ()=>import('../views/sells.vue')
  },
  {
    path:'/accountInfo',
    name:'accountInfo',
    component: ()=>import('../views/accountInfo.vue')
  },
  {
    path:'/sellProduct',
    name:'sellProduct',
    component: ()=>import('../views/sellProduct.vue')
  },
  {
    path:'/claimApplication',
    name:'claimApplication',
    component: ()=>import('../views/claimApplication.vue')
  },
  {
    path:'/claimDetail/:id',
    name:'claimDetail',
    component: ()=>import('../views/claimDetail.vue')
  },
  {
    path:'/remind',
    name:'remind',
    component: ()=>import('../views/remind.vue')
  },
  {
    path:'/orderList',
    name:'orderList',
    component: ()=>import('../views/orderList.vue')
  },{
    path:'/orderPList/:zh',
    name:'orderPList',
    component: ()=>import('../views/orderList.vue')
  },
  {
    path:'/policy',
    name:'policy',
    component: ()=>import('../views/policy.vue')
  },
  {
    path:'/policyModify/:code',
    name:'policyModify',
    component: ()=>import('../views/policyModify.vue')
  },
  {
    path:'/completePolicyOrder/:code/:orderCode',
    name:'completePolicyOrder',
    component: ()=>import('../views/policyModify.vue')
  },
  {
    path:'/claim',
    name:'claim',
    component: ()=>import('../views/claim.vue')
  },
  {
    path:'/account',
    name:'account',
    component: ()=>import('../views/account.vue')
  },
  {
    path:'/invoice',
    name:'invoice',
    component: ()=>import('../views/invoice.vue')
  },
  {
    path:'/common',
    name:'common',
    component: ()=>import('../views/common.vue')
  },
  {
    path:'/occupation',
    name:'occupation',
    component: ()=>import('../views/occupation.vue')
  },
  {
    path:'/download',
    name:'download',
    component: ()=>import('../views/download.vue')
  },
  {
    path:'/claiminfo/:id',
    name:'claiminfo',
    component: ()=>import('../views/claiminfo.vue')
    
  },
  {
    path:'/claimSq',
    name:'claimSq',
    component: ()=>import('../views/claimSq.vue')
    
  },
  {
    path:'/showOrder/:id',
    name:'showOrder',
    component: ()=>import('../views/showOrder.vue')
    
  },
  {
    path:'/notice/:pcode/:fcode/:bzzq/:zylb',
    name:'notice',
    component: ()=>import('../views/notice.vue')
  },
  { 
    path: '/order',
    name:'order',
    component: ()=>import('../views/order.vue')
  },
  {
    //完善订单
    path: '/productOrder/:pcode/:fcode/:bzzq/:zylb',
    name:'productOrder',
    component: ()=>import('../views/order.vue')
  },
  {
    //完善订单
    path: '/completeOrder/:code',
    name:'completeOrder',
    component: ()=>import('../views/order.vue')
  },
  {
    //续保
    path: '/renewOrder/:policyId',
    name:'renewOrder',
    component: ()=>import('../views/renewOrder.vue')
  },
  {
    //重新投保
    path: '/againPolicy/:policyId',
    name:'againPolicy',
    component: ()=>import('../views/againOrder.vue')
  },
  {
    //重新投保
    path: '/againOrder/:orderCode',
    name:'againOrder',
    component: ()=>import('../views/againOrder.vue')
  },
  {
    //订单详情
    path: '/orderInfo/:code',
    name:'orderInfo',
    component: ()=>import('../views/showOrder.vue')
  },
  {
    //保单详情
    path:'/policyDetail/:code',
    name:'policyDetail',
    component: ()=>import('../views/policyDetail.vue')
  },
  {
    //确认订单
    path:'/confirm/:code',
    name:'confirm',
    component: ()=>import('../views/confirm.vue')
  },
  { 
    path:'/pay/:code',
    name:'pay',
    component: ()=>import('../views/pay.vue')
  },
  { 
    path:'/paySuccess',
    name:'paySuccess',
    component: ()=>import('../views/paySuccess.vue')
  },
  {
    path:'/orderSuccess',
    name:'orderSuccess',
    component: ()=>import('../views/orderSuccess.vue')
  },
  {
    path:'/balanceList',
    name:'balanceList',
    component: ()=>import('../views/balanceList.vue')
  },
  {
    path:'/creditQuotaList',
    name:'creditQuotaList',
    component: ()=>import('../views/creditQuotaList.vue')
  }
 
]
//创建路由器对象
const router = createRouter({
  //定义路由模式：history模式，hash模式
  history: createWebHistory(),
  //路由数组
  routes
})
//确保每次打开页面都自动滚动到顶部
// 在 router/index.js 中
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  next();
});

//导出路由对象
export default router